import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

const hiddenText = {
    overflow: "hidden",
    textOverflow: "ellipsis",
};

export const menuWidth = 240;

export const useNestedSelectStyles = makeStyles((theme: Theme) => ({
    startIcon: {
        marginRight: 0,
    },
    iconEnd: {
        width: 24,
        height: 24,
    },
    menu: {
        width: menuWidth,
        maxHeight: 400,
    },
    parent: {
        cursor: "default",
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        },
    },
    group: {
        width: "100%",
        "& button": {
            fontSize: 10,
        },
    },
    selectedText: {
        maxWidth: 150,
        whiteSpace: "nowrap",
        ...hiddenText,
    },
    parentText: {
        maxWidth: 150,
        ...hiddenText,
    },
    text: {
        ...hiddenText,
    },
    groupText: {
        fontSize: 12,
        maxWidth: 75,
        ...hiddenText,
    },
}));
